
// ROUTES
require('modules/transfer/routes/transfer');

// CONTROLLERS
require('modules/transfer/controllers/transfer');
require('modules/transfer/controllers/list');
require('modules/transfer/controllers/create');
require('modules/transfer/controllers/edit');

// SERVICES
require('modules/transfer/services/transfer');
require('modules/transfer/services/list');
require('modules/transfer/services/create');
require('modules/transfer/services/edit');
require('modules/transfer/services/delete');


angular.module('unica_transfer', [

	// ROUTES
	'unica_transfer.transfer_routes',

	// CONTROLLERS
	'unica_transfer.transfer_controllers',

	// SERVICES
	'unica_transfer.transfer_services'

]);